
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/device-temperature",
      function () {
        return require("private-next-pages/device-temperature/index.jsx");
      }
    ]);
  